import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = localStorage.getItem("projectId");

export const BalanceOpBalNet = createAsyncThunk(
  "TrialBalance/BalanceOpBalNet",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/BalanceOpBalNet`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BalanceTFormat = createAsyncThunk(
  "TrialBalance/BalanceTFormat",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/BalanceTFormat`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BalanceSheetSlice = createSlice({
  name: "FAS",
  initialState: {
    OpBalNetdata: null,
    BTFormatdata: null,
    status: "idle",
    error: null,
  },
  reducers: {
    OpBalNetFan: (state) => {
      state.OpBalNetdata = null;
    },
    BTFormatFan: (state) => {
      state.OpBalNetdata = null;
    },
    BalanceTFormatFan: (state) => {
      state.BTFormatdata = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(BalanceOpBalNet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BalanceOpBalNet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.OpBalNetdata = action.payload;
      })
      .addCase(BalanceOpBalNet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BalanceTFormat.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BalanceTFormat.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BTFormatdata = action.payload;
      })
      .addCase(BalanceTFormat.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { OpBalNetFan, BTFormatFan, BalanceTFormatFan } =
  BalanceSheetSlice.actions;

export default BalanceSheetSlice.reducer;
